import { useAuth } from 'vl-common/src/context/provider.app';

export function useUser(throwError = false) {
  const [auth] = useAuth();

  if (!auth.user && throwError) {
    throw Error('User record expected to have been set');
  }

  return auth.user;
}

export const useUserSafe = () => {
  const [auth] = useAuth();

  return auth.user;
};

export default useUser;
